import React from 'react'

import Stack from 'react-bootstrap/Stack'

import AccessPassListItem from './AccessPassListItem'

export default function AccessPassesList({ accessPasses, onTransferred }) {
  return (
    <Stack gap={3} as="ul" className="list-unstyled m-0">
      {accessPasses?.map((accessPass) => (
        <AccessPassListItem
          key={accessPass.uuid}
          accessPass={accessPass}
          onTransferred={onTransferred}
        />
      ))}
    </Stack>
  )
}
